import { isHeadlessBrowser } from '@/utils/isHeadlessBrowser';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useMediaQuery } from '../use-media-query';
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);
export function useInsetReveal(containerRef, selector = '[data-media-wrapper]') {
    const isDesktop = useMediaQuery('(min-width: 768px)', false);
    useGSAP(() => {
        if (isHeadlessBrowser()) {
            return;
        }
        gsap
            .timeline({
            scrollTrigger: {
                markers: process.env.NODE_ENV === 'development',
                trigger: containerRef.current,
                // Smooth the animation by interpolating between scroll positions
                scrub: 2,
                // Run animation when component is at the top and user scrolls through
                start: 'top top',
                end: 'bottom bottom',
            },
        })
            .fromTo(selector, {
            clipPath() {
                if (isDesktop) {
                    return 'inset(0px 96px)';
                }
                return 'inset(0px 28px)';
            },
        }, {
            clipPath: 'inset(0px 0px)',
            duration: 1,
        }, 0)
            .fromTo(`${selector} img, ${selector} video`, {
            scale: 1,
        }, {
            scale: 1.2,
            duration: 1,
        }, 0);
    }, { scope: containerRef, dependencies: [isHeadlessBrowser] });
}
